<template>
    <div>
        <input class="text-input" :type="inputType" v-bind:class="{ 'text-input-error': field.has_error }" v-model="inputVal">
    </div>
</template>

<script>
export default {
    props: ['field', 'value'],
    computed: {
        inputType: function () {
            return this.field.options.include_time ? 'datetime-local' : 'date'
        },
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>
